import { combineReducers } from 'redux';
import areasSlice from '../slices/areasSlice';
import categoriesSlice from '../slices/categoriesSlice';
import editorSlice from '../slices/editorSlice';
import elementsSlice from '../slices/elementsSlice';
import organisationUnitsSlice from '../slices/organisationUnitsSlice';
import personsSlice from '../slices/personsSlice';
import rolesSlice from '../slices/rolesSlice';
import spaceSlice from '../slices/spaceSlice';
import wildcardPersonsSlice from '../slices/wildcardPersonsSlice';
import headerSlice from '../slices/headerSlice';
import organisationSlice from '../slices/organisationSlice';
import permissionsSlice from '../slices/permissionsSlice';
import personEditorSlice from '../slices/personEditorSlice';
import roleSlice from '../slices/roleSlice';
import rootmenuSlice from '../slices/rootmenuSlice';
import statusTableSlice from '../slices/statusTableSlice';
import systemSlice from '../slices/systemSlice';
import systemSettingsSlice from '../slices/systemSettingsSlice';
import taskListSlice from '../slices/taskListSlice';
import traineeSlice from '../slices/traineeSlice';
import trainingAndOwnershipsSlice from '../slices/trainingAndOwnershipsSlice';
import trainingSlice from '../slices/trainingSlice';
import userSlice from '../slices/userSlice';
import userSettings from '../slices/userSettingsSlice';
import groupsSlice from '../slices/groupsSlice';
import trainingSessionsSlice from '../slices/trainingSessionsSlice';

const rootReducer = combineReducers({
  areas: areasSlice,
  categories: categoriesSlice,
  elements: elementsSlice,
  editor: editorSlice,
  header: headerSlice,
  groups: groupsSlice,
  organisation: organisationSlice,
  organisationUnits: organisationUnitsSlice,
  permissions: permissionsSlice,
  personEditor: personEditorSlice,
  persons: personsSlice,
  role: roleSlice,
  roles: rolesSlice,
  rootmenu: rootmenuSlice,
  statusTable: statusTableSlice,
  system: systemSlice,
  systemSettings: systemSettingsSlice,
  taskList: taskListSlice,
  trainee: traineeSlice,
  training: trainingSlice,
  trainingSessions: trainingSessionsSlice,
  trainingAndOwnerships: trainingAndOwnershipsSlice,
  spaces: spaceSlice,
  user: userSlice,
  userSettings,
  wildcardPersons: wildcardPersonsSlice,
});

export default rootReducer;
